// Controlled vocabulary for the `amenities[]` field on Place.
// This is the v1 list — extendable as new patterns surface during enrichment.
//
// IMPORTANT: amenity keys here should NOT duplicate the dedicated boolean
// fields on Place. The booleans are the canonical signal for those features.
// Don't add an "outlets" amenity key — use `place.outlets === true` instead.
// Same for: wifi → `place.wifi`, outdoor-seating → `place.outdoorSeating`.

export const AMENITY_KEYS = [
  "air-conditioning",
  "large-tables",
  "pet-friendly",
  "live-music",
  "kid-friendly",
  "private-room",
  "parking",
  "smoking-area",
  "counter-only",
  "bookshop",
  "record-shop",
  "coworking",
  "terrace",
  "riverside",
  "beachfront",
  "ocean-view",
  "ricefield-view",
  "pool",
  "late-night-kitchen",
  "breakfast-served",
  "vegan-options",
  "gluten-free-options",
] as const;

export type AmenityKey = (typeof AMENITY_KEYS)[number];

export function isAmenityKey(value: string): value is AmenityKey {
  return (AMENITY_KEYS as readonly string[]).includes(value);
}
